const CONNECTOR_ID_DELIMITER = '--'
export const createCompositeConnectorId = ({
  chargerId,
  connectorId
}: {
  chargerId?: string
  connectorId?: string | number
}) => `${chargerId ?? ''}${CONNECTOR_ID_DELIMITER}${String(connectorId ?? '')}`

export const parseStableConnectorId = (compositeId: string): { chargerId: string; connectorId: string } | null => {
  const idx = compositeId.indexOf(CONNECTOR_ID_DELIMITER)
  if (idx === -1) return null
  const chargerId = compositeId.substring(0, idx)
  const connectorId = compositeId.substring(idx + CONNECTOR_ID_DELIMITER.length)
  if (!chargerId || !connectorId) return null
  return { chargerId, connectorId }
}
